import { render, staticRenderFns } from "./wxyuceRevise.vue?vue&type=template&id=efd07f88"
import script from "./wxyuceRevise.vue?vue&type=script&lang=js"
export * from "./wxyuceRevise.vue?vue&type=script&lang=js"
import style0 from "./wxyuceRevise.vue?vue&type=style&index=0&id=efd07f88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports